import { SET_CLIENT_VIDEOS } from "../actions/action-types.js";

export default function clientVideos(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_VIDEOS:
            return (state = payload)
        default:
            return state
    }
}